import { useMemo } from 'react'
import { useGuild } from '../config/context/guild'
import PremiumBenefitCategory, {
  PointDistribution,
  PointsSpentByCategory,
  PREMIUM_BENEFIT_CONFIG,
  premiumBenefitCategories,
} from 'app/frontend/types/custom/PremiumBenefitCategory'
import { legacyPoints } from '../pages/GuildDashboard/components/PremiumBenefits'
import { usePageInfo } from '../config/queries'

const useGuildBenefits = () => {
  const { guild } = useGuild()
  const {
    data: { user },
  } = usePageInfo()

  const benefits = guild?.premiumBenefits || []
  const legacyTier = guild?.legacyPatron?.details?.pledge_tier

  return useMemo(() => {
    return premiumBenefitCategories.reduce((acc, category) => {
      const otherOrLegacy =
        benefits
          .filter((b) => b.userId !== user?.id && b.category === category)
          .reduce((acc, b) => acc + b.points, 0) +
        legacyPoints[legacyTier || 'Free'][category]

      const own = benefits
        .filter((b) => b.userId === user?.id && b.category === category)
        .reduce((acc, b) => acc + b.points, 0)

      const level = Math.min(
        PREMIUM_BENEFIT_CONFIG[category].max,
        PREMIUM_BENEFIT_CONFIG[category].min +
          (otherOrLegacy + own) * PREMIUM_BENEFIT_CONFIG[category].step,
      )

      acc[category] = { otherOrLegacy, own, total: otherOrLegacy + own, level }
      return acc
    }, {} as PointsSpentByCategory & { [key in PremiumBenefitCategory]: PointDistribution & { level: number } })
  }, [guild, user])
}

export default useGuildBenefits
